{
    "de": {
        "LEGEND_DESCRIPTION": "Legende Betriebszustand"
    },
    "en": {
        "LEGEND_DESCRIPTION": "Legend operating status"
    }
}
